import React from 'react';

// import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import './ReBuy.css';
import '../App.css';

import CtNumericInpunt from '../ct-numeric-inpunt';
import { Form, Row, Col, Icon, Input, Button } from 'antd';
import { actions } from '../../store/index';

const FormItem = Form.Item;
const dimension = 18;

// const mapStateToProps = state => ({});
// const bid = async () => {

// };

const _bid = async (params) => {
  await actions.bid(params);
  window.location.href = window.location.href;
};

const hasErrors = fieldsError =>
  Object.keys(fieldsError).some(field => fieldsError[field]);

const newLocal = 1.1;
// Form.create(
// @connect(mapStateToProps)
class ReBuy extends React.Component {
  static propTypes = {
    state: PropTypes.string,
    price: PropTypes.string,
    isRenter: PropTypes.bool.isRequired,
    form: PropTypes.object,
    getFieldDecorator: PropTypes.object,
    setFieldsValue: PropTypes.object,
  };

  state = {
    visible: false,
  };

  componentWillMount() {
    this.props.form.validateFields();
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps = (newProps) => {
    if (
      !newProps.state ||
      (newProps.state && (newProps.state === 'rent' && !newProps.isRenter))
    ) {
      this.setState({ visible: true });
    } else {
      this.setState({ visible: false });
    }
  };

  getBillboardsInputs() {
    const { getFieldDecorator } = this.props.form;
    const children = [];
    for (let i = 0; i < 3; i++) {
      children.push(<FormItem label="" key={i}>
        {getFieldDecorator(`d${i + 1}`, {
          rules: [
            {
              required: true,
              message: 'Input something!',
            },
          ],
        })(<Input placeholder={`Billboard ${i + 1}`} />)}
      </FormItem>);
    }
    return children;
  }

  handleAmountChange = value =>
    this.props.form.setFieldsValue({
      amount: value,
    });

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        const params = {
          // value: values.amount * Math.pow(10, dimension),
          value: values.amount,
          text: [].concat(values.d1, values.d2, values.d3),
        };
        console.log(params);
        _bid(params);
      }
    });
  };

  render() {
    const loading = false;
    const {
      getFieldDecorator,
      getFieldsError,
      isFieldTouched,
      getFieldError,
    } = this.props.form;
    // const price = this.props.price / Math.pow(10, dimension) + 0.01;
    const price = 1.1 * this.props.price;
    const amountError = isFieldTouched('amount') && getFieldError('amount');
    return (
      <div>
        {' '}
        {this.state.visible ? (
          <div className="b-form">
            <div className="b-form__span">
              <span>{`You can re-buy this billboards at ${price}`}</span>
            </div>
            <Form layout="inline" onSubmit={this.handleSubmit}>
              <Row gutter={24}>{this.getBillboardsInputs()}</Row>
              <FormItem
                validateStatus={amountError ? 'error' : ''}
                help={amountError || ''}
              >
                {getFieldDecorator('amount', {
                  rules: [{ required: true, message: 'Please input amount!' }],
                })(<CtNumericInpunt
                  disabled={loading}
                  style={{ width: 160 }}
                  onChange={this.handleAmountChange}
                />)}
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={hasErrors(getFieldsError())}
                >
                  Re buy
                </Button>
              </FormItem>
            </Form>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default Form.create()(ReBuy);



// WEBPACK FOOTER //
// ./src/components/re-buy/ReBuy.js